const queryString = require('query-string');

function search(searchQuery) {
    const currentFilters = queryString.parse(location.search);
    currentFilters.search = searchQuery;
    const query = queryString.stringify(currentFilters);
    window.location.href = `/careers/openings/?${query}`;
}

module.exports = search;
